import React from "react";
import { Flame, Zap, Construction, Mountain, FlaskConical, Factory, Waves, Droplets, Fuel, Cpu } from "lucide-react";

const PILLS = [
  { icon: Flame, label: "Refineries · LNG · Hydrogen" },
  { icon: Zap, label: "Generation · T&D · BESS" },
  { icon: Construction, label: "Roads · Rails · Metros" },
  { icon: Mountain, label: "Metals & Mining" },
  { icon: FlaskConical, label: "Basic & Specialty Chemicals" },
  { icon: Factory, label: "Discrete & Process Manufacturing" },
  { icon: Waves, label: "Ports · Shipbuilding" },
  { icon: Droplets, label: "Desalination · Water Recycling" },
  { icon: Fuel, label: "Upstream · Pipelines · Downstream" },
  { icon: Cpu, label: "Data Centers · Hyperscale" },
];

export function TrustBar() {
  const doubled = [...PILLS, ...PILLS];
  return (
    <section className="trust" data-testid="trust-bar-section">
      <div className="container">
        <div className="trust-label">
          Where capital is at stake — the terrain we operate in.
        </div>
        <div className="trust-marquee">
          <div className="trust-track">
            {doubled.map((p, i) => {
              const Icon = p.icon;
              return (
                <div className="trust-pill" key={i} data-testid={`trust-pill-${i}`}>
                  <span className="trust-pill-icon"><Icon size={16} /></span>
                  <span>{p.label}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
